import React from 'react';
import PropTypes from 'prop-types';
import DateTimeDisplay from './DateTimeDisplay';

const CallbackDateWidget = ({ value }) => (
  <DateTimeDisplay
    label="This was scheduled for "
    value={value}
    withAlert
    hideIfInvalid
  />
);

CallbackDateWidget.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

export default CallbackDateWidget;



// WEBPACK FOOTER //
// ./src/components/CallbackDateWidget.js